import { mapToList } from "./utils";

// 资商通分账履约方式枚举
export const EnumZstRoyaltyDeliverType = {
  A: "ALIPAY_ALLOC",
  B: "DUANWAI_ALLOC",
  C: "MANUAL_ALLOC",
  D: "FINAL_ALLOC",
  E: "OFFLINE_ALLOC",
  F: "EARLY_BUY_BACK_ALLOC",
  G: "OVERDUE_ALLOC",
};

// 资商通分账履约方式到文字的映射
export const ZstRoyaltyDeliverTypeToTextMap = new Map([
  [EnumZstRoyaltyDeliverType.A, "支付转分账"],
  [EnumZstRoyaltyDeliverType.B, "端外代偿分账"],
  [EnumZstRoyaltyDeliverType.C, "手工代偿分账"],
  [EnumZstRoyaltyDeliverType.D, "尾差代偿分账"],
  [EnumZstRoyaltyDeliverType.E, "线下结清分账"],
  [EnumZstRoyaltyDeliverType.F, "提前回购分账"],
  [EnumZstRoyaltyDeliverType.G, "超期代偿分账"],
]);

// 资商通分账履约方式列表（用于下拉选择等场景）
export const ZstRoyaltyDeliverTypeList = mapToList(ZstRoyaltyDeliverTypeToTextMap);

// 根据资商通分账履约方式值获取文字描述
export function getZstRoyaltyDeliverTypeText(type) {
  return ZstRoyaltyDeliverTypeToTextMap.get(type) || type;
}

// 资商通分账类型枚举
export const EnumZstRoyaltyType = {
  PERIOD: 1, // 按期分账
  BUYOUT: 2, // 提前买断分账
  CANCEL: 3, // 订单取消分账
  EARLY_BUYBACK: 4, // 提前回购分账
};

// 资商通分账类型到文字的映射
export const ZstRoyaltyTypeToTextMap = new Map([
  [EnumZstRoyaltyType.PERIOD, "按期分账"],
  [EnumZstRoyaltyType.BUYOUT, "提前买断分账"],
  [EnumZstRoyaltyType.CANCEL, "订单取消分账"],
  [EnumZstRoyaltyType.EARLY_BUYBACK, "提前回购分账"],
]);

// 资商通分账类型列表（用于下拉选择等场景）
export const ZstRoyaltyTypeList = mapToList(ZstRoyaltyTypeToTextMap);

// 根据资商通分账类型值获取文字描述
export function getZstRoyaltyTypeText(type) {
  return ZstRoyaltyTypeToTextMap.get(type) || type;
}

// 资商通分账状态枚举
export const EnumZstRoyaltyStatus = {
  A: 1, // 分账中
  B: 2, // 已完成分账
  C: 3, // 已分账
};

// 资商通分账状态到文字的映射
export const ZstRoyaltyStatusToTextMap = new Map([
  [EnumZstRoyaltyStatus.A, "分账中"],
  [EnumZstRoyaltyStatus.B, "已完成分账"],
  [EnumZstRoyaltyStatus.C, "回购中"],
]);

// 资商通分账状态列表（用于下拉选择等场景）
export const ZstRoyaltyStatusList = mapToList(ZstRoyaltyStatusToTextMap);

// 根据资商通分账状态值获取文字描述
export function getZstRoyaltyStatusText(status) {
  return ZstRoyaltyStatusToTextMap.get(status) || status;
}


// 资商通分账明细状态枚举
export const EnumZstRoyaltyBillStatus = {
  NONE: 0, // 无需分账
  WAIT: 1, // 待分账
  DONE: 2, // 已分账
  CLOSED: 3, // 已关闭
};

// 资商通分账明细状态到文字的映射
export const ZstRoyaltyBillStatusToTextMap = new Map([
  [EnumZstRoyaltyBillStatus.NONE, "无需分账"],
  [EnumZstRoyaltyBillStatus.WAIT, "待分账"],
  [EnumZstRoyaltyBillStatus.DONE, "已分账"],
  [EnumZstRoyaltyBillStatus.CLOSED, "已关闭"],
]);

// 资商通分账明细状态列表（用于下拉选择等场景）
export const ZstRoyaltyBillStatusList = mapToList(ZstRoyaltyBillStatusToTextMap);

// 根据资商通分账明细状态值获取文字描述
export function getZstRoyaltyBillStatusText(status) {
  return ZstRoyaltyBillStatusToTextMap.get(status) || status;
}
